module.exports = __webpack_public_path__ + "media/images/svg/facebook-7d3324b298180bdf2b35e27f840abdb2.svg";